import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { Link, useSearchParams, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import AuthLayout from '../Components/AuthLayout';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { resetPassword } from '../redux/actions/authActions';

function ResetPassword() {
  const { register, handleSubmit, watch, formState: { errors }, reset } = useForm();
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { resetPasswordLoading, resetPasswordError } = useSelector(state => state.auth);
  
  const token = searchParams.get('token');
  
  const onSubmit = async (data) => {
    if (!token) {
      alert('Invalid reset link. Please request a new password reset.');
      return;
    }
    
    try {
      await dispatch(resetPassword(token, data.password));
      // Clear form after successful submission
      reset();
      // Redirect to login page after successful password reset
      setTimeout(() => {
        navigate('/login');
      }, 500); // Wait 2 seconds to show success message
    } catch (error) {
      // Error is already handled in the action creator
      console.error('Reset password error:', error);
    }
  };
  const password = watch('password');
  // const inputStyle = {
  //   background: '#fff',
  //   borderRadius: 4,
  //   fontSize: 15,
  //   color: '#111',
  // };
  return (
    <AuthLayout>
      <h2 style={{ fontWeight: 800, marginBottom: 22, textAlign: 'left', fontFamily: 'Inter, sans-serif', color: '#e2e8f0' }}>Reset password</h2>
      {/* {!token && (
        <div style={{ marginBottom: 20, padding: 12, background: '#dc2626', borderRadius: 8, color: '#fff', textAlign: 'center' }}>
          Invalid reset link. Please request a new password reset.
        </div>
      )} */}
      <form onSubmit={handleSubmit(onSubmit)} noValidate>
          <div style={{ marginBottom: 14 }}>
            <TextField
              label="New Password"
              type={showPassword ? 'text' : 'password'}
              fullWidth
              variant="outlined"
              size="small"
              InputProps={{
                style: { background: 'transparent', color: '#e2e8f0' },
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={() => setShowPassword((show) => !show)} edge="end" size="small">
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              sx={{
                '& .MuiOutlinedInput-root fieldset': { borderColor: '#334155' },
                '& .MuiOutlinedInput-root:hover fieldset': { borderColor: '#64748b' },
                '& .MuiOutlinedInput-root.Mui-focused fieldset': { borderColor: '#ffffff' },
                '& .MuiInputBase-input': { color: '#e2e8f0' },
                '& .MuiInputLabel-root': { color: '#e2e8f0' },
                '& .MuiInputLabel-root.Mui-focused': { color: '#ffffff' },
                '& .MuiInputLabel-root.MuiInputLabel-shrink': { color: '#e2e8f0' },
                '& input:-webkit-autofill': {
                  WebkitBoxShadow: '0 0 0 1000px #1d283a inset',
                  WebkitTextFillColor: '#e2e8f0',
                  caretColor: '#e2e8f0',
                },
              }}
              {...register('password', { required: 'New password is required' })}
              error={!!errors.password}
              helperText={errors.password ? errors.password.message : ''}
            />
          </div>
          <div style={{ marginBottom: 20 }}>
            <TextField
              label="Confirm New Password"
              type={showConfirm ? 'text' : 'password'}
              fullWidth
              variant="outlined"
              size="small"
              InputProps={{
                style: { background: 'transparent', color: '#e2e8f0' },
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={() => setShowConfirm((show) => !show)} edge="end" size="small">
                      {showConfirm ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              sx={{
                '& .MuiOutlinedInput-root fieldset': { borderColor: '#334155' },
                '& .MuiOutlinedInput-root:hover fieldset': { borderColor: '#64748b' },
                '& .MuiOutlinedInput-root.Mui-focused fieldset': { borderColor: '#ffffff' },
                '& .MuiInputBase-input': { color: '#e2e8f0' },
                '& .MuiInputLabel-root': { color: '#e2e8f0' },
                '& .MuiInputLabel-root.Mui-focused': { color: '#ffffff' },
                '& .MuiInputLabel-root.MuiInputLabel-shrink': { color: '#e2e8f0' },
                '& input:-webkit-autofill': {
                  WebkitBoxShadow: '0 0 0 1000px #1d283a inset',
                  WebkitTextFillColor: '#e2e8f0',
                  caretColor: '#e2e8f0',
                },
              }}
              {...register('confirmPassword', {
                required: 'Confirm password is required',
                validate: value => value === password || 'Passwords do not match',
              })}
              error={!!errors.confirmPassword}
              helperText={errors.confirmPassword ? errors.confirmPassword.message : ''}
            />
          </div>
          <Button
            type="submit"
            fullWidth
            variant="contained"
            disabled={resetPasswordLoading || !token}
            sx={{ background: '#2563eb', color: '#fff', fontWeight: 700, fontSize: 16, mb: 1, borderRadius: 2, py: 1, '&:hover': { background: '#1e40af' }, '&:disabled': { background: '#64748b' } }}
          >
            {resetPasswordLoading ? 'Resetting...' : 'Reset Password'}
          </Button>
        </form>
        <div style={{ textAlign: 'center', marginTop: 12 }}>
          <Link to="/login" style={{ color: '#94a3b8', fontWeight: 500, textDecoration: 'none' }}>Back to Login</Link>
        </div>
    </AuthLayout>
  );
}

export default ResetPassword;
